import { useConnectedClient } from 'context/ConnectedClientContext';

export const useBillingIsTracks = () => {
  const { details } = useConnectedClient();

  return {
    enabled: details?.ConnectedTeam?.settings?.billing?.tracks?.enabled ?? false,
  };
};
